import { FC, ReactNode } from 'react'
import { Text } from '@mrshmllw/smores-react'

import { InputContainer } from 'directFlow/commonStyles'

import { validateEmail } from 'utils'

type EmailInputContainerProps = {
  value: string | undefined | null
  children: (completed?: boolean) => ReactNode
}

export const EmailInputContainer: FC<EmailInputContainerProps> = ({ value, children }) => {
  const emailValidation = validateEmail(value)
  const emailTypoWarning = emailValidation?.warning
  const completed = emailValidation.isValid && !emailTypoWarning && !!value

  return (
    <InputContainer>
      {children(completed)}
      {emailTypoWarning && (
        <Text typo="caption" mt={{ custom: '-16px' }}>
          {emailValidation?.message}
        </Text>
      )}
    </InputContainer>
  )
}
